export default "__VITE_ASSET__B3CkN2_L__"